import "./App.css";
import "./styles/main.css";
import "./styles/tailwind.css"
import Register from "./Authentication/Register.jsx";
import Login from "./Authentication/Login.jsx";
import Home from "./pages/Home.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "jquery/dist/jquery.js";
import "popper.js";
import { Route } from "react-router-dom";
import Navbar from "./Components/Navbar.jsx";
import HommieViewCard from "./Authentication/HommieViewCard";
import Footer from "./Components/Footer.jsx";
import Logout from "./Authentication/Logout.jsx";
import SinglePost from "./pages/SinglePost";
import SingleUser from "./pages/SingleUser";
import EditProfile from "./Components/EditProfile";
import CreatePost from "./Components/CreatePost";
import EditPost from "./Components/EditPost";
import ReportIssue from "./pages/ReportIssue";
import MobileMenu from "./Components/MobileMenu.jsx";
import Search from "./pages/Search";
import GamesBoard from "./pages/GamesBoard";
import GuessingGamePage from "./pages/GuessingGamePage";
import WordPuzzleGamePage from "./pages/WordPuzzleGamePage";
import CustomSwitch from "./CustomSwitch";
import MessagesPage from "./pages/MessagesPage";
import React from "react";
import UserContext from "./UserContext";
import Test from "./pages/Test";
import Explore from "./pages/Explore";
import ResetPassword from "./Authentication/ResetPassword";
import HomeChangePassword from "./Authentication/HomeChangePassword";
import Verify from "./pages/Verify";
import FingersBattle from "./pages/FingersBattlePage";
import ChangePassword from "./pages/ChangePassword";

function App() {
  // setting the theme
  const { mode } = React.useContext(UserContext);
  const [dark, setDark] = React.useState(false);
  const [loggedIn, setloggedIn] = React.useState(false);

  React.useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.token) {
      setloggedIn(true);
    }
  }, [mode]);

  return (
    <div
      className={
        dark === true ? "app darkmode min-h-screen" : "app min-h-screen"
      }
    >
      <Navbar></Navbar>
      <CustomSwitch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route exact path="/test">
          <Test />
        </Route>
        <Route exact path="/verify">
          <Verify />
        </Route>
        <Route exact path="/p/:id">
          <SinglePost />
        </Route>
        <Route exact path="/users/:username">
          <SingleUser />
        </Route>
        <Route exact path="/logout">
          <Logout />
        </Route>
        <Route exact path="/reset-password">
          <HommieViewCard component={ResetPassword}></HommieViewCard>
        </Route>
        <Route exact path="/confirm-reset-password">
          <HommieViewCard component={HomeChangePassword}></HommieViewCard>
        </Route>
        <Route exact path="/games">
          <GamesBoard />
        </Route>

        <Route exact path="/games/guess-it">
          <GuessingGamePage />
        </Route>
        <Route exact path="/games/word-puzzle">
          <WordPuzzleGamePage />
        </Route>

        <Route exact path="/games/fingers-battle">
          <FingersBattle />
        </Route>

        <Route exact path="/issues">
          <ReportIssue></ReportIssue>
        </Route>

        <Route exact path="/search">
          <Search></Search>
        </Route>

        <Route exact path="/messages">
          <MessagesPage></MessagesPage>
        </Route>

        {/* <Route exact path="/register" component={Register}></Route> */}
        <Route exact path="/register">
          <HommieViewCard component={Register}></HommieViewCard>
        </Route>
        {/* <Route exact path="/login" component={Login}></Route> */}
        <Route exact path="/login">
          <HommieViewCard component={Login}></HommieViewCard>
        </Route>
        <Route exact path="/edit-profile">
          <EditProfile />
        </Route>
        <Route exact path="/change-password">
          <ChangePassword />
        </Route>

        <Route exact path="/create-post">
          <CreatePost />
        </Route>
        <Route exact path="/edit-post/:postid">
          <EditPost />
        </Route>

        <Route exact path="/verify">
          <Verify />
        </Route>

        <Route exact path="/explore">
          <Explore />
        </Route>
        <Route path="*">
          <div style={{ minHeight: "54vh" }}>404 -- Page Not Found</div>
        </Route>
      </CustomSwitch>
      <div className="fixed  lg:hidden z-40 w-full bottom-0">
        <MobileMenu />
      </div>
      {!loggedIn && (
        <div className="hidden  lg:block z-40 w-full bottom-0">
          <Footer />
        </div>
      )}
    </div>
  );
}

export default App;
